import { useState } from 'react'
// import { styled } from '@mui/material/styles'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitleSkippable } from '$common/app-bar/app-bar-back-title-skippable'
import { SearchInput } from '$common/input'
import { APP_BAR_HEIGHT } from '$common/app-bar/app-bar.constants'
import { nothing } from '$func/utils'
import { useWindowHeight } from '$helper/functions/window.react-hook'

const SEARCH_FIELD_HEIGHT = 55

export interface WithAppBarAndSearchFieldProps {
  appBarTitle: string
  skippable?: boolean
  selectionLimit?: number
  selectionCount: number
  onBack: () => void
  onSkip?: () => unknown
  onConfirm: () => never | Promise<never>
  loading?: boolean
  children: (listHeight: number, searchQuery: string) => JSX.Element
  subtractHeight?: number
}

export function WithAppbarAndSearchField({
  appBarTitle,
  skippable = false,
  selectionCount,
  onBack,
  onConfirm,
  onSkip = nothing,
  loading = false,
  children,
  selectionLimit = 0,
  subtractHeight = 0,
}: WithAppBarAndSearchFieldProps) {
  const windowHeight = useWindowHeight()
  const [query, setQuery] = useState<string>('')

  const listHeight =
    windowHeight - APP_BAR_HEIGHT - SEARCH_FIELD_HEIGHT - subtractHeight

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitleSkippable
          selectionLimit={selectionLimit}
          selectionCount={selectionCount}
          skippable={skippable}
          title={appBarTitle}
          onBack={onBack}
          onSkip={onSkip}
          onConfirm={onConfirm}
        />
      }
    >
      <SearchInput disabled={loading} query={query} onQueryChange={setQuery} />

      {children(listHeight, query)}
    </PageWithAppBar>
  )
}
